module.exports = __webpack_public_path__ + "img/main.48168032.svg";